import { Container, DestroyOptions } from "pixi.js";
import { Group } from "tweedle.js";
import { BackGroundComponent } from "../components/backGround/BackGroundComponent";
import { JpMeterComponent } from "../components/JpMeters/JpMeterComponent";
import { LogoComponent } from "../components/logo/LogoComponent";
import { ReelFrameComponent } from "../components/reels/ReelFrameComponent";
import { WinMeterComponent } from "../components/winmeters/WinMeterComponent";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
import { IScene } from "../core/interfaces";
import { Manager } from "../core/Manager";
import { Reels } from "../core/reelsHoldSpin/Reels";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { BigWin } from "./BigWin";

export abstract class HoldBaseScene extends Container implements IScene {
    assets: string[] = [];

    assetBundles: string[] = [];

    protected tweenGroup = new Group();
    protected reels: Reels | null = null;
    protected bigWin: BigWin | null = null;
    protected background = new Container();
    protected reelFrame = new Container();
    protected game = new Container();

    public abstract constructorWithAssets(): Promise<void>;

    protected initBaseLayering() {
        this.initBackground();
        //this.game.addChild(this.reelFrame);
        this.game.label = "game";
        this.addChild(this.background);
        this.addChild(this.game);
    }

    //@ts-ignore
    protected initBackground() {
        DisplayComponent.register(new DisplayComponentFactory(BackGroundComponent));
        const backGround = DisplayComponent.get(BackGroundComponent);
        backGround.init();
        this.addChild(backGround.getInstance());
    }

    protected addComponent(Comp: any, parent?: Container): any {
        DisplayComponent.register(new DisplayComponentFactory(Comp));
        const component = DisplayComponent.get(Comp);
        component.init();
        //@ts-ignore
        const instance = component.getInstance();
        parent?.addChild(instance);
        return instance;
    }

    protected setupCommonUI() {
        this.addComponent(LogoComponent, this.game);
        this.addComponent(WinMeterComponent, this.game);
        //this.addComponent(JpMeterComponent, this.background);
    }

    protected setupReelFrame(skel: string, atlas: string, animate: boolean) {
        DisplayComponent.register(new DisplayComponentFactory(ReelFrameComponent));
        DisplayComponent.get(ReelFrameComponent).setAnim(skel, atlas);
        const reelBack = DisplayComponent.get(ReelFrameComponent).getInstance();
        this.reels.addChildAt(reelBack, 0);
        this.reelFrame.addChild(this.reels);

        this.reelFrame.eventMode = "static";

        // this.graphics = new Graphics()
        //     .rect(0, 0, 1300, 1250)
        //     .fill(0xDE3249);

        // this.graphics.alpha = 0.01;
        // this.reels.addChild(this.graphics);
        reelBack.position.set(499, 337);
        this.reels.position.set(-493, -193);

        const alpha = animate ? 0 : 1;
        this.reelFrame.alpha = alpha;
    }

    protected initJpMeter() {
        DisplayComponent.register(new DisplayComponentFactory(JpMeterComponent));
        const jpMeter = DisplayComponent.get(JpMeterComponent);
        jpMeter.init();
        this.background.addChild(jpMeter.getInstance());
    }


    public update(): void {
        this.tweenGroup.update();
        this.reels?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        const isLandscape = screenWidth > screenHeight;
        const scale = isLandscape ? Math.min(screenWidth / GameConstants.GAME_RES_WIDTH, screenHeight / GameConstants.GAME_RES_HEIGHT) : Math.min(screenWidth / GameConstants.GAME_RES_HEIGHT, screenHeight / GameConstants.GAME_RES_WIDTH);
        console.log("Hold BaseScene resize with scale:", scale);
        this.game.scale.set(scale);
        this.game.position.set(-(GameConstants.BACKGROUND_SIZE * scale - screenWidth) / 2, -(GameConstants.BACKGROUND_SIZE * scale - screenHeight) / 2);
        console.log(this.game.position.x, this.game.position.y);
        [this.game, this].forEach(cont => cont.children.forEach(c => {
            if (c instanceof DisplayObject) c.setPositionResize(Manager.Orientation);
        }));

    }

    override destroy(options?: DestroyOptions) {
        [BackGroundComponent, LogoComponent, ReelFrameComponent, WinMeterComponent]
            .forEach((c: any) => DisplayComponent.unregister(c));
        super.destroy(options);
    }
}